import { createAction } from '@reduxjs/toolkit';

export const CREATE_GREETING_ACTION_TYPE = 'saga/createGreeting';
export const createGreetingAction = createAction(CREATE_GREETING_ACTION_TYPE);
